import { PageHeader } from '@/components/layout/PageHeader'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useAppAuth } from '@/contexts/app-auth.context'

const MANUAL_PHONE_PROVISIONING_FLAG = 'manual_phone_provisioning'

export function CompanySettingsSkeleton() {
  const { featureFlags } = useAppAuth()
  const showPhoneSkeleton = featureFlags.includes(
    MANUAL_PHONE_PROVISIONING_FLAG,
  )

  return (
    <div className="space-y-6 p-6 pt-0">
      <PageHeader title="Manage your company details and preferences" />

      <Card>
        <CardHeader>
          <CardTitle>Company Details</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div className="max-w-md">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-10 w-full" />
            </div>
            <div className="max-w-md">
              <Skeleton className="h-4 w-16 mb-2" />
              <Skeleton className="h-10 w-full" />
            </div>
            <div className="space-y-2">
              <Skeleton className="h-4 w-28 mb-2" />
              <div className="space-y-2">
                {Array.from({ length: 7 }).map((_, i) => (
                  <div key={i} className="flex items-center gap-4">
                    <Skeleton className="h-4 w-16" />
                    <Skeleton className="h-8 w-20" />
                    <Skeleton className="h-4 w-4" />
                    <Skeleton className="h-8 w-20" />
                  </div>
                ))}
              </div>
            </div>
            <Skeleton className="h-10 w-24" />
          </div>
        </CardContent>
      </Card>

      {showPhoneSkeleton && (
        <Card>
          <CardHeader>
            <CardTitle>Phone Number</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-3">
              <Skeleton className="h-4 w-64" />
              <Skeleton className="h-10 w-56" />
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
